import {ApplicationDTO, EnrollmentDTO, TermDTO} from "../core/dto";
import ApplicationDetailDrawer from "../app/modal/ApplicationDetailDrawer";
import {EnumLabels, tEnum} from "./translations";
import EnrollmentDetailDrawer from "../app/modal/EnrollmentDetailDrawer";
import TermDetailDrawer from "../app/modal/TermDetailDrawer";
// import EnrollmentDetailDrawer from "../app/modal/EnrollmentDetailDrawer";




export const EntityRegistry = {
    application: {
        title: "Başvurular",
        endpoint: "/application",
        exportEndpoint: "/application/export",
        mapper: ApplicationDTO.list,


        columns: [
            {key: "fullName", label: "Ad Soyad", sortable: true},
            {key: "email", label: "E-posta"},
            {key: "phone", label: "Telefon"},
            {
                key: "status",
                label: "Durum",
                render: v =>
                    <span className={`badge badge-${v?.toLowerCase()}`}>
            {tEnum("STATUS", v)}
        </span>
            },
            {
                key: "applicationChannel",
                label: "Kanal",
                render: (v) => tEnum("APPLICATION_CHANNEL", v),
            },
            {
                key: "createdAt",
                label: "Kayıt Tarihi",
                render: v =>
                    new Date(v).toLocaleDateString("tr-TR", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric"
                    })
            }




        ],

        filters: [
            // 🔎 SEARCH FIELDS
            {type: "search", key: "firstName", label: "Ad"},
            {type: "search", key: "lastName", label: "Soyad"},

            {type: "search", key: "email", label: "E-posta"},
            {type: "search", key: "phoneNumber", label: "Telefon"},

            {type: "cityTurkey", key: "city", label: "Şehir"},

            // 🎯 SELECT FIELDS
            {
                type: "select",
                key: "status",
                label: "Durum",
                options: [
                    {value: "NEW", label: "Yeni"},
                    {value: "REVIEWING", label: "İncelemede"},
                    {value: "APPROVED", label: "Onaylandı"},
                    {value: "REJECTED", label: "Reddedildi"},
                    {value: "WITHDRAWN", label: "Vazgeçti"}
                ]
            },
            {
                type: "select",
                key: "applicationChannel",
                label: "Kanal",
                options: [
                    {value: "ONLINE", label: "Online"},
                    {value: "PHYSICAL", label: "Fiziksel"},
                ]
            },
            {
                type: "select",
                key: "gender",
                label: "Cinsiyet",
                options: [
                    {value: "MALE", label: "Erkek"},
                    {value: "FEMALE", label: "Kadın"}
                ]
            },



            // 📅 DATE RANGE
            {type: "date", key: "createdFrom", label: "Başlangıç Tarihi"},
            {type: "date", key: "createdTo", label: "Bitiş Tarihi"},
        ],

        detailEndpoint: "/application",
        detailMapper: ApplicationDTO.detail,


        detailComponent: ApplicationDetailDrawer
    },

    enrollment: {
        title: "Kayıtlar",
        endpoint: "/enrollment",
        exportEndpoint: "/enrollment/export",
        mapper: EnrollmentDTO.list,

        columns: [
            {key: "fullName", label: "Öğrenci"},
            {key: "phone", label: "Telefon"},
            {
                key: "status",
                label: "Durum",
                render: v =>
                    <span className={`badge badge-${v?.toLowerCase()}`}>
            {tEnum("ENROLLMENT_STATUS", v)}
        </span>
            },
            { key: "termName", label: "Dönem" },
            {key: "enrolledAt", label: "Kayıt Tarihi"},
        ],

        filters: [

            { type: "termSelect", key: "termPublicId", label: "Dönem" },

            { type: "search", key: "firstName", label: "Ad" },
            { type: "search", key: "lastName", label: "Soyad" },
            { type: "search", key: "email", label: "E-posta" },

            { type: "countryDial", key: "countryCode", label: "Ülke kodu" },
            { type: "search", key: "phoneNumber", label: "Telefon" },

            { type: "cityTurkey", key: "city", label: "Şehir" },
            { type: "search", key: "nationality", label: "Uyruk" },


            // 🎯 SELECT FIELDS
            {
                type: "select",
                key: "status",
                label: "Durum",
                options: [
                    { value: "ACTIVE", label: "Aktif" },
                    { value: "COMPLETED", label: "Tamamlandı" },
                    { value: "DROPPED", label: "Bıraktı" },
                    { value: "SUSPENDED", label: "Dondurdu" }
                ]
            },

            {
                type: "select",
                key: "gender",
                label: "Cinsiyet",
                options: [
                    { value: "MALE", label: "Erkek" },
                    { value: "FEMALE", label: "Kadın" }
                ]
            },

            {
                type: "select",
                key: "interestArea",
                label: "İlgi Alanı",
                options: [
                    { value: "COACHING", label: "Antrenörlük" },
                    { value: "MANAGEMENT", label: "Yönetim" },
                    { value: "REFEREE", label: "Hakemlik" },
                    { value: "PLAYER_ANALYSIS", label: "Oyuncu Analizi" },
                    {value: "SPORTS_JOURNALISM", label: "Spor Yazarlığı"}
                ]
            },

            {
                type: "select",
                key: "source",
                label: "Kaynak",
                options: [
                    { value: "MANUAL", label: "Manuel" },
                    { value: "SYSTEM", label: "Sistem" }
                ]
            },

            // 📅 DATE RANGE
            { type: "date", key: "createdFrom", label: "Başlangıç Tarihi" },
            { type: "date", key: "createdTo", label: "Bitiş Tarihi" },
        ],


        detailEndpoint: "/enrollment",   // backend neyse
        detailMapper: EnrollmentDTO.detail,     // DTO sen yazarsın

        detailComponent: EnrollmentDetailDrawer

    },

    term: {
        title: "Dönemler",
        endpoint: "/terms",
        mapper: TermDTO.list,
        columns: [
            { key: "name", label: "Dönem Adı" },
            { key: "code", label: "Kod" },
            {
                key: "startDate",
                label: "Başlangıç",
                render: (v) => v ? new Date(v).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "-"
            },
            {
                key: "endDate",
                label: "Bitiş",
                render: (v) => v ? new Date(v).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : "-"
            },
            { key: "enrollmentCount", label: "Öğrenci" },
            { key: "type", label: "Tip", render: (v) => tEnum("TERM_TYPE", v) },
            {
                key: "isDefault",
                label: "Durum",
                render: (v, row) =>
                    v
                        ? `Aktif${row.isApplicationOpen ? " · Form açık" : " · Form kapalı"}`
                        : "Pasif",
            }
        ],
        filters: [],
        detailEndpoint: "/terms",
        detailMapper: TermDTO.detail,
        detailComponent: TermDetailDrawer,
    },
};
